import "./GarageDoorRepairCanterburyBankstown.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import ServiceAreaIntroduction from "./sections/ServiceAreaIntroduction";
import Services from "./sections/Services";
import PartnershipLogos from "./sections/PartnershipLogos";
import ServiceProcess from "./sections/ServiceProcess";
import ValuePropositions from "./sections/ValuePropositions";
import Suburbs from "./sections/Suburbs";
import Testimonials from "./sections/Testimonials";
import CanterburyBankstownFaq from "./sections/CanterburyBankstownFaq";
import Contact from "./sections/Contact";
import SiteFooter from "./sections/SiteFooter";
export default function GarageDoorRepairCanterburyBankstownPage() {
  return <div>
      <Header />
      <HeroBanner />
      <ServiceAreaIntroduction />
      <Services />
      <PartnershipLogos />
      <ServiceProcess />
      <ValuePropositions />
      <Suburbs />
      <Testimonials />
      <CanterburyBankstownFaq />
      <Contact />
      <SiteFooter />
    </div>;
}